import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { css } from 'emotion';
import Image from 'shared/Image';
import { ImagePicker } from 'shared/ImagePicker';

const noop = () => null;

const ChoosePathScene = ({
  imageErrorText,
  coverArtImageUrl,
  onChooseSearchPath,
  onChooseUploadPath,
  onChooseRandomPath,
}) => {
  const [imagePickerErrorText, setImagePickerErrorText] = useState(null);
  return (
    <>
      <Modal.Title>Choose your cover art</Modal.Title>
      {coverArtImageUrl && (
        <Modal.Subtitle>First, you&apos;ll need an image.</Modal.Subtitle>
      )}
      <Modal.Body
        className={css`
          && {
            max-width: 200px;
            max-height: 200px;
            margin: 16px auto 0 auto;
          }
        `}
      >
        {coverArtImageUrl === '' ? (
          <Image
            imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/cover-art/cover-art-maker-hero.png"
            retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/cover-art/cover-art-maker-hero@2x.png"
            height="100%"
            objectFit="contain"
          />
        ) : (
          <div
            className={css`
              display: inline-block;
              border-radius: 8px;
              overflow: hidden;
            `}
          >
            <Image imageUrl={coverArtImageUrl} height={200} width={200} />
          </div>
        )}
      </Modal.Body>
      {(imageErrorText || imagePickerErrorText) && (
        <Modal.Error>{imageErrorText || imagePickerErrorText}</Modal.Error>
      )}
      <div
        className={css`
          display: grid;
          grid-gap: 16px;
          grid-template-rows: repeat(3, 1fr);
          justify-content: center;
          margin-top: 32px;
          button {
            width: 100%;
          }
        `}
      >
        <ButtonPrimary onClick={onChooseSearchPath}>
          Search for a photo
        </ButtonPrimary>
        <ImagePicker
          inputId="upload-file-coverart"
          onChange={fileObj => {
            setImagePickerErrorText(null);
            onChooseUploadPath(fileObj);
          }}
          onError={handledErrorText =>
            setImagePickerErrorText(handledErrorText)
          }
          dims={{
            minWidth: 0,
            maxWidth: 1000000000000,
            minHeight: 0,
            maxHeight: 100000000000,
          }}
        >
          <ButtonPrimary>Upload an image</ButtonPrimary>
        </ImagePicker>
        <ButtonPrimary onClick={onChooseRandomPath}>
          Choose one for me
        </ButtonPrimary>
      </div>
    </>
  );
};

ChoosePathScene.defaultProps = {
  onChooseSearchPath: noop,
  onChooseUploadPath: noop,
  onChooseRandomPath: noop,
  coverArtImageUrl: '',
  imageErrorText: null,
};

ChoosePathScene.propTypes = {
  onChooseSearchPath: PropTypes.func,
  onChooseUploadPath: PropTypes.func,
  onChooseRandomPath: PropTypes.func,
  coverArtImageUrl: PropTypes.string,
  imageErrorText: PropTypes.string,
};

export { ChoosePathScene };
